import React, { useCallback, useEffect, useState } from "react";
import { Copy, Mail, Send } from "lucide-react";
import { practiceApi } from "../../lib/practiceApi";

const TONE = { "NON INVIATA": "neutral", INVIATA: "warning", VISUALIZZATA: "success" };
const TEMPLATE_LABEL = { impresa: "modello impresa", autonomo: "modello lavoratore autonomo" };

export const DocRequestBar = ({ siteId, companyId, testId }) => {
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState("");
  const [error, setError] = useState("");

  const load = useCallback(() => practiceApi(`/coordination/${siteId}/companies/${companyId}/doc-request`)
    .then(setState).catch(err => setError(err.message)), [siteId, companyId]);
  useEffect(() => { load(); }, [load]);

  async function send() {
    setBusy(true); setError("");
    try {
      const result = await practiceApi(`/coordination/${siteId}/companies/${companyId}/doc-request`, { method: "POST" });
      setState(result);
      await navigator.clipboard.writeText(result.url).catch(() => {});
      setCopied("Link generato e copiato: invialo all'impresa");
      setTimeout(() => setCopied(""), 6000);
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  }

  if (!state) return null;
  return <div className="doc-request-bar" data-testid={testId}>
    <button className="ghost" disabled={busy} data-testid={`${testId}-send`} onClick={send}>
      <Send size={13} />{busy ? "Genero il link…" : "Invia richiesta documenti"}
    </button>
    <span className={`practice-badge ${TONE[state.status] || "neutral"}`} data-testid={`${testId}-status`}>{state.status}</span>
    <small>{TEMPLATE_LABEL[state.template] || state.template}{state.opened_at ? ` · aperta il ${state.opened_at.slice(0, 10).split("-").reverse().join("/")}` : ""}</small>
    {state.url && <>
      <a href={state.url} target="_blank" rel="noopener noreferrer" data-testid={`${testId}-link`}><Mail size={13} />Apri pagina impresa</a>
      <button className="icon-btn" title="Copia link" data-testid={`${testId}-copy`} onClick={() => { navigator.clipboard.writeText(state.url); setCopied("Link copiato"); setTimeout(() => setCopied(""), 4000); }}><Copy size={13} /></button>
    </>}
    {copied && <em data-testid={`${testId}-copied`}>{copied}</em>}
    {error && <em className="doc-request-error">{error}</em>}
  </div>;
};

export const DocStateSelect = ({ siteId, companyId, item, onSaved, testId }) => {
  const mode = item.state?.mode || (item.file ? "file" : "");
  const [note, setNote] = useState(item.state?.note || "");
  const [busy, setBusy] = useState(false);

  async function change(next) {
    setBusy(true);
    try {
      await practiceApi(`/coordination/${siteId}/companies/${companyId}/doc-state/${item.doc_type}`, {
        method: "POST", body: JSON.stringify({ mode: next, note }),
      });
      onSaved();
    } catch (err) { alert(err.message); } finally { setBusy(false); }
  }

  return <div className="doc-state" data-testid={testId}>
    <select value={mode || "file"} disabled={busy} data-testid={`${testId}-mode`} onChange={e => change(e.target.value)}>
      <option value="file">File caricato</option>
      <option value="verificato">Verificato dal coordinatore</option>
      <option value="presa_visione">Presa visione</option>
      <option value="non_presente">Non presente / da richiedere</option>
    </select>
    {mode === "verificato" && <small data-testid={`${testId}-verified`}>
      {`Verificato il ${String(item.state?.at || "").slice(0, 10).split("-").reverse().join("/")} da ${item.state?.by_name || ""}${item.state?.source === "ai" ? " · INGEGO AI" : ""}`}
    </small>}
    {mode === "presa_visione" && <>
      <input placeholder="Nota sulla presa visione" value={note} disabled={busy} data-testid={`${testId}-note`}
        onChange={e => setNote(e.target.value)} onBlur={() => note !== (item.state?.note || "") && change("presa_visione")} />
      <small data-testid={`${testId}-ack`}>{`Presa visione il ${String(item.state?.at || "").slice(0, 10).split("-").reverse().join("/")} da ${item.state?.by_name || ""}`}</small>
    </>}
  </div>;
};
